import React from "react";
import { WishListDeleteBody } from "tsi-common-react/src/apps/customer-account/WishListDeleteBody/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.WishListDeleteDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <WishListDeleteBody {...props} />
    </PageSkeleton>
);
